import { useState } from 'react';
import { WarehoueZones } from '.';
import { LocationFeedPopup } from '../LocationFeedPopup';
import { WarehouseForm } from './warehouseForm';
import { useWarehouseDetails } from '../../../screens/app/settings/warehouse';
import { Button } from 'antd';

export function WarehouseDetailTab({ zones, zoneLoading, zoneRefresh }) {
  const [openFeedPopup, setOpenFeedPopup] = useState(false);
  const { warehouseId } = useWarehouseDetails();
  return (
    <div className="row mt-2">
      <div className="pl-0 col-5">
        <WarehouseForm />
      </div>
      <div className="col-7 pl-0 pr-0">
        <WarehoueZones
          zones={zones}
          zoneLoading={zoneLoading}
          zoneRefresh={zoneRefresh}
        />
        <Button
          variant="outlined"
          className="mt-4"
          onClick={() => setOpenFeedPopup(true)}
        >
          Bulk Upload
        </Button>
        <LocationFeedPopup
          open={openFeedPopup}
          onClose={() => setOpenFeedPopup(false)}
          warehouseId={warehouseId}
        />
      </div>
    </div>
  );
}
